import { ClientDataService, IClientDataDoc } from '../../../services/clientData.service'

export class PatientDemographicsService extends ClientDataService {
  private BLOOD_TYPE_OPTIONS_DOC = 'tb_bloodtype'
  private COUNTRY_OPTIONS_DOC = 'tb_country'
  private EMAIL_TYPE_OPTIONS_DOC = 'tb_email_type'
  private SEX_OPTIONS_DOC = 'tb_util_sex'
  private GENDER_OPTIONS_DOC = 'tb_util_gender'
  private PHONE_TYPE_OPTIONS_DOC = 'tb_phone_types'
  private RACE_OPTIONS_DOC = 'tb_prrace'
  private STATE_OPTIONS_DOC = 'tb_state'
  private SUFFIX_OPTIONS_DOC = 'tb_util_generation'
  private TRIAGE_COLOR_OPTIONS_DOC = 'tb_prtriage'
  private DL_STATE_OPTIONS_DOC = 'tb_state'
  private DNR_STATUS_DOCS = 'v_prdnr'
  private WEIGHT_DOCS = 'tb_demographics-patientweightunit-custom'
  private HEIGHT_DOCS = 'tb_demographics-patientheightunit-custom'
  private AGE_DOCS = 'tb_demographics-patientageunit-custom'
  private PHYSICIAN_TYPE_DOCS = 'tb_physician_type'
  private BARRIERS_TO_CARE = 'tb_prcommbar'
  private INDUSTRY_OPTIONS_DOC = 'tb_nhtsa_industry'
  private OCCUPATION_OPTIONS_DOCS = 'tb_nhtsa_occupation'
  private IMMUNIZATION_STATUS_OPTIONS_DOCS = 'tb_immune_status'
  private IMMUNIZATION_TYPE_OPTIONS_DOCS = 'tb_nhtsa_immune'
  private PREFERRED_LANGUAGE_OPTIONS = 'tb_nemsis3_foreign_languages'
  private RESIDENCE_OPTIONS = 'tb_ptresident_status'
  private ALT_HOME_RESIDENCE_OPTIONS = 'tb_pt_althomeresidence'

  async getBloodTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.BLOOD_TYPE_OPTIONS_DOC)
  }

  async getCountryOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.COUNTRY_OPTIONS_DOC)
  }

  async getDLStateOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DL_STATE_OPTIONS_DOC)
  }

  async getEmailTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.EMAIL_TYPE_OPTIONS_DOC)
  }

  async getSexOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SEX_OPTIONS_DOC)
  }

  async getGenderOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.GENDER_OPTIONS_DOC)
  }

  async getPhoneTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PHONE_TYPE_OPTIONS_DOC)
  }

  async getRaceOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.RACE_OPTIONS_DOC)
  }

  async getStateOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.STATE_OPTIONS_DOC)
  }

  async getSuffixOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.SUFFIX_OPTIONS_DOC)
  }

  async getTriageColorOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.TRIAGE_COLOR_OPTIONS_DOC)
  }

  async getWeightOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.WEIGHT_DOCS)
  }

  async getHeightOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.HEIGHT_DOCS)
  }

  async getAgeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.AGE_DOCS)
  }

  async getDnrStatusOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.DNR_STATUS_DOCS)
  }

  async getPhysicianTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PHYSICIAN_TYPE_DOCS)
  }

  async getBarriersToCareOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.BARRIERS_TO_CARE)
  }

  async getIndustryOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.INDUSTRY_OPTIONS_DOC)
  }

  async getOccupationOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.OCCUPATION_OPTIONS_DOCS)
  }

  async getImmunizationStatusOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.IMMUNIZATION_STATUS_OPTIONS_DOCS)
  }

  async getImmunizationTypeOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.IMMUNIZATION_TYPE_OPTIONS_DOCS)
  }

  async getPreferredLanguageOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.PREFERRED_LANGUAGE_OPTIONS)
  }

  async getResidenceOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.RESIDENCE_OPTIONS)
  }

  async getAltHomeResidenceOptions(): Promise<IClientDataDoc | undefined | null> {
    return await this.getDocument(this.ALT_HOME_RESIDENCE_OPTIONS)
  }
}
